import {BS2Statics} from "../config/BS2Statics";
import {BS2} from "../BS2";
import {gsap} from "gsap";

export class BS2AddTextToProgressionBarView extends PIXI.Container {
    private _finalPos: PIXI.Point = new PIXI.Point(360, 650);

    // private _finalPos: { x: number, y: number } = {x: 360, y: 650};

    constructor() {
        super();
    }

    public emptyContainer(): void {
        this.removeChildren();
    }

    public moveToProgressionBar(reelIdx: number, symIdx: number, symName: string, durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.removeChild(text);
            }
        })
        const text: PIXI.Sprite = this.createTextObj(reelIdx, symIdx, symName);
        const obj: { x: number, y: number } = {x: text.position.x, y: text.position.y};
        tl.to(text, {alpha: 1, duration: durr / 3});
        tl.to(text.scale, {x: 1.2, y: 1.2, duration: durr / 3}, "<");
        tl.to(text.scale, {x: 1, y: 1, duration: durr / 6});

        tl.add(gsap.to(obj, {
                motionPath: {
                    path: [{
                        x: obj.x,
                        y: obj.y
                    }, {
                        x: (2 - reelIdx) < 0 ? (obj.x - 20) : (reelIdx === 2 ? obj.x : obj.x + 20),
                        y: obj.y - 50
                    }, {
                        x: this._finalPos.x,
                        y: this._finalPos.y
                    }],
                    curviness: 0.8,
                },
                ease: "power1.inOut",
                duration: durr,
                onUpdate: (value) => {
                    text.position.set(obj.x, obj.y);
                }
            })
        );
        const alphaDurr: number = 2 * (durr / 3);
        tl.to(text, {
            alpha: 0,
            duration: durr - alphaDurr
        }, `<${alphaDurr}`);
        return tl;
    }

    private createTextObj(reelIdx: number, symIdx: number, symName: string): PIXI.Sprite {
        let addVal: string = "";
        if (BS2Statics.MID_SYMBOLS.includes(symName)) {
            addVal = "+1";
        } else if (BS2Statics.HIGH_SYMBOLS.includes(symName)) {
            addVal = "+2";
        } else if (symName === BS2Statics.SYMBOLS.S) {
            addVal = "+10";
        }
        const text: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures("progression_bar_adding_text/" + addVal)[0]);
        text.alpha = 0;
        this.addChild(text);
        text.position.set((BS2Statics.SYMBOL_WIDTH * reelIdx) + BS2Statics.REEL_AREA_X_OFFSET, (BS2Statics.SYMBOL_HEIGHT * symIdx) + BS2Statics.REEL_AREA_Y_OFFSET);
        text.pivot.set(text.width / 2, text.height / 2);
        text.scale.set(0.4, 0.4);
        return text;
    }
}